import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useState, useEffect } from 'react';
import cocowho from './media/img/coco-who.png'
import silogo from './media/img/sj3.png'
// import { Provider } from 'react-redux';
// import { Store } from './redux/store';

// components
import NavBar from './components/navbar';
import Footer from './components/footer';

// pages
import Home from './pages/home';

// library_-_styles
import './styles/aos.css'


// styles
import './styles/main.css'
import './styles/flex-system.css'
import './styles/grid-system.css'
import './styles/text.css'
import './styles/spacing.css'
import './styles/responsive.css'
import './styles/effect.css'

// 
import './styles/lightslider.css'

// custom_-_js_-_files
import './scripts/main';

const LoadingComp = () => (
        <div className={`onLoading`}>
            <div className="onLoading-box">
                <img src={silogo} alt="" />
            </div>
        </div>
    )

function App() {

  const [loading, setloading] = useState(true)

  useEffect(() => {
          const timer = setTimeout(() => {
          setloading(null);
          }, 4000);
  
          return () => clearTimeout(timer);
      }, []);
  
      if (loading) {
          return <LoadingComp />;
      }

  return (
    // <Provider store={Store}>
        
      <BrowserRouter>

      <NavBar />

      <Routes>

        <Route 
          index
          path='/'
          element={<Home />}
        />

      </Routes>

    </BrowserRouter>

    // </Provider>
  );
}

export default App;
